import brand from '@/brand'
export default [
  {
    path: '/auth/login',
    name: 'auth.login',
    component: () => import('../../views/auth/LoginView.vue'),
    meta: {
      title: `Prihlásenie - ${brand.siteName}`,
      requiresGuest: true,
      layout: 'auth'
    }
  },
  {
    path: '/auth/register',
    name: 'auth.register',
    component: () => import('../../views/auth/RegisterView.vue'),
    meta: {
      title: `Registrácia - ${brand.siteName}`,
      requiresGuest: true,
      layout: 'auth'
    }
  },
  {
    path: '/auth/verify-email',
    name: 'auth.verify-email',
    component: () => import('../../views/auth/VerifyEmailView.vue'),
    meta: {
      title: `Overenie emailu - ${brand.siteName}`,
      requiresGuest: true,
      layout: 'auth'
    }
  },
  {
    path: '/auth/forgot-password',
    name: 'auth.forgot-password',
    component: () => import('../../views/auth/ForgotPasswordView.vue'),
    meta: {
      title: `Zabudnuté heslo - ${brand.siteName}`,
      requiresGuest: true,
      layout: 'auth'
    }
  },
  {
    path: '/auth/reset-password',
    name: 'auth.reset-password',
    component: () => import('../../views/auth/ResetPasswordView.vue'),
    meta: {
      title: `Obnovenie hesla - ${brand.siteName}`,
      requiresGuest: true,
      layout: 'auth'
    }
  },
  {
    path: '/auth/change-password',
    name: 'auth.change-password',
    component: () => import('../../views/auth/ChangePasswordView.vue'),
    meta: {
      title: `Zmena hesla - ${brand.siteName}`,
      requiresAuth: true,
      layout: 'user'
    }
  }
]
